import React from 'react'

import HeaderInfo from "./header/HeaderInfo"
import DataPicture from "./data/DataPicture"
import DataAside from "./aside/DataAside"
import DataMemo from "./DataMemo"
import HeaderButtons from "./header/HeaderButtons.jsx"
import LoginButtons from "./header/login/LoginButtons"


export default function Container({section, apiData, localData, state, setSection}) {
  return (
    <div className="container main-bg">
           <header>
             <HeaderInfo/>
             <HeaderButtons section={section} setSection={setSection}/>
             <LoginButtons></LoginButtons>
           </header>
           <div className="pokemon-data-container">
             <div className="data-subcontainer">
               <DataPicture apiData={apiData} localData={localData} state={state} />
               <DataAside apiData={apiData} localData={localData} />
             </div>
             <div className="data-memo">
               <div className="data--item--left item--left">
                 <p>TRAINER MEMO</p>
               </div>
               <DataMemo className="nature" localData={localData} />
             </div>
           </div>
         </div>
  )
}
